<template src="./menu-categorias-produto.html"></template>
<style lang="less" src="./menu-categorias-produto.less" scoped></style>

<script>
import { mapActions, mapState } from "vuex";
import categoria from "@/mixins/categoria.mixin";

const MenuCategoriasProduto = "MenuCategoriasProduto";
const ListagemDeProduto = "ListagemDeProduto";

export default {
  mixins: [categoria],
  computed: {
    ...mapState(MenuCategoriasProduto, ["categorias", "ordenacaoDeAZ"]),

    ...mapState(ListagemDeProduto, ["filtersEdit"]),

    categoriaSelecionada() {
      return this.filtersEdit?.categoriaId;
    },

    distinctCategorias() {
      return (
        this.categorias
          ?.reduce((list, cat) => {
            if (!list.some((x) => x.id === cat?.id)) return [...list, cat];
            return list;
          }, [])
          ?.filter((x) => Boolean(x)) || []
      );
    },

    possuiCategorias() {
      return this.categorias.length > 0;
    },

    ordernacaoDeAZ() {
      return this.ordenacaoDeAZ;
    },
  },
  created() {
    this.buscarCategorias();
  },
  methods: {
    ...mapActions(MenuCategoriasProduto, [
      "buscarCategorias",
      "ordenarDeAaZ",
      "ordenarDeZaA",
    ]),

    ...mapActions(ListagemDeProduto, ["setCategoriaId"]),

    ordenarDeAZ() {
      this.ordenarDeAaZ();
    },
    ordenarDeZA() {
      this.ordenarDeZaA();
    },
    categoriaClicked(categoriaId) {
      this.setCategoriaId({ categoriaId, fetchProdutos: true });
      this.$emit("hideSidebar");
    },
    isActive(id) {
      return id === this.categoriaSelecionada;
    },
  },
};
</script>